import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.select = this.el.querySelector('.js-conditions-admission-select');
        this.content = this.el.querySelector('.js-conditions-admission-content');

        let id = this.select.id;

        // check if there is a query string for index and hash for select id
        const url = new URL(window.location.href);
        const index = url.searchParams.get('index');
        const hash = url.hash;
        if (hash === '#' + id && index) {
            this.select.selectedIndex = index;
            this.content.querySelectorAll('.o-admission__item.is-active').forEach(el => {
                el.classList.remove('is-active');
            });
            this.content.children[index].classList.add('is-active');
        } else {
            this.content.children[0].classList.add('is-active');
        }
        this.select.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
        const index = this.select.selectedIndex;

        this.content.querySelectorAll('.o-admission__item.is-active').forEach(el => {
            el.classList.remove('is-active');
        });
        this.content.children[index].classList.add('is-active');

        // replace history state with a query string for index and hash for select id
        const url = new URL(window.location.href);
        url.searchParams.set('index', index);
        url.hash = this.select.id;
        window.history.replaceState({}, '', url);

        try {
            if (this.select.value !== 'no-value') {
                dataLayer.push({
                    'event': 'criteres_admission',
                    'page_category': 'Critères d\'admission',
                    'departement': programInfos.departement,
                    'cycle': programInfos.cycle,
                    'diplome': programInfos.diplome,
                    'programme_code': programInfos.code,
                    'programme_nom': programInfos.name,
                    'critere_admission': this.select.value,
                });
            }
        }
        catch(e) {

        }
    }

    destroy() {
        this.select.removeEventListener('change', this.onChange.bind(this));
    }
}
